import { DataSourceFormat } from '@/resources/enum';
import { ShapeBaseAttribute } from './base';
export class ImageArrayAttribute extends ShapeBaseAttribute {
  /**
   *填充类型
   *
   * @type {('digits' | 'normal')}
   * @memberof ImageArrayAttribute
   */
  fillType?: '数字填充' | '普通填充';

  /**
   * 数字填充：对齐方式
   * @type {('left' | 'rigt' | 'center')}
   * @memberof ImageArrayAttribute
   */
  align?: 'left' | 'right' | 'center' = 'left';

  /**
   * 数字填充：图片间距(-127~127)
   */
  space?: number = 0;

  /**
   * 数字填充：图片间距(-127~127)
   */
  widgetSpace?: number = 0;

  /**
   * 普通填充且数据源进度精度
   *
   * @memberof ImageArrayAttribute
   */
  sourceProgressAccuracy = 10;

  /**
   * 数据源进度精度自定义
   *
   * @memberof ImageArrayAttribute
   */
  sourceProgressCustom?: number[][];

  /**
   * 天气类型
   *
   * @type {('whole' | 'simple')}
   * @memberof ImageArrayAttribute
   */
  sourceWeatherType: 'whole' | 'simple' = 'whole';

  /**
   * 数据源格式
   * @type
   */
  sourceFormat?: DataSourceFormat;

  /**
   * 数据源12/24小时模式
   */
  sourceHourMode: 'system' | '12h' | '24h' = 'system';

  resources: {
    images?: LayerResourceItem;
    decimalIcon?: LayerResourceItem;
    unitIcon?: LayerResourceItem;
    /**
     * 多单位下的第二个单位
     */
    unitIcon2?: LayerResourceItem;
    /**
     * ifttt无数据时显示的图片
     */
    iftttEmptyImage?: LayerResourceItem;
  } = {};

  decimalOffsetX? = '0';

  // 是否有尾零
  trailingZero = false;

  /** 小数点位数 （默认为最大精度） */
  decimalDigits: number | undefined;

  /**
   * 指南针帧率
   *
   * @memberof ImageAttribute
   */
  compassFps = 50;

  // 缩放
  scale?: number;

  // 透明度
  alpha?: number;

  // 是否单独设置缩放，判断是否跟随全局缩放
  isSetSingleScale?: boolean;
}
